/**
 * @generated SignedSource<<7f93f05c40d54e9c9e0a2eadb6b1a419>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
export type WorkspaceAsideVersionQuery$variables = {
  owner: string;
  slug: string;
  version: Semver;
};
export type WorkspaceAsideVersionQuery$data = {
  readonly workspaceBySlug: {
    readonly version: {
      readonly clonedFrom: {
        readonly id: string;
        readonly version: Semver;
        readonly workspace: {
          readonly id: string;
          readonly slug: string;
        };
      } | null | undefined;
      readonly createdAt: DateTime;
      readonly doi: {
        readonly full: string;
      } | null | undefined;
      readonly entity: {
        readonly username: string;
        readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
      };
      readonly fromCompetition: {
        readonly events: {
          readonly nodes: ReadonlyArray<{
            readonly event: {
              readonly slug: string;
            };
          }>;
        };
        readonly id: string;
        readonly slug: string;
        readonly title: string;
      } | null | undefined;
      readonly id: string;
      readonly publishedAt: DateTime | null | undefined;
      readonly version: Semver;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceDOIFragment" | "WorkspaceVersionCardActionsFragment">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceAsideFragment">;
  } | null | undefined;
};
export type WorkspaceAsideVersionQuery = {
  response: WorkspaceAsideVersionQuery$data;
  variables: WorkspaceAsideVersionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "version"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "version"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "full",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkspaceVersion",
  "kind": "LinkedField",
  "name": "clonedFrom",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        (v9/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "DOI",
  "kind": "LinkedField",
  "name": "doi",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "short",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "entity",
  "plural": false,
  "selections": [
    (v14/*:: as any*/),
    (v5/*:: as any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isEntity"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageThumbnail",
      "storageKey": null
    },
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v9/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Competition",
  "kind": "LinkedField",
  "name": "fromCompetition",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    (v11/*:: as any*/),
    (v9/*:: as any*/),
    {
      "alias": null,
      "args": (v12/*:: as any*/),
      "concreteType": "EventCompetitionConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventCompetition",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v16/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "events(first:1)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompetitionStage",
      "kind": "LinkedField",
      "name": "currentStage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "submissionDeadline",
          "storageKey": null
        },
        (v3/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": "viewerCanPublish",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "PUBLISH_WORKSPACE_VERSION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"PUBLISH_WORKSPACE_VERSION\")"
},
v19 = {
  "alias": "viewerCanCreateVersion",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_WORKSPACE_VERSION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_WORKSPACE_VERSION\")"
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    (v9/*:: as any*/),
    (v19/*:: as any*/)
  ],
  "storageKey": null
},
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v22 = {
  "alias": null,
  "args": (v21/*:: as any*/),
  "concreteType": "SubmissionConnection",
  "kind": "LinkedField",
  "name": "submissions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Submission",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            (v14/*:: as any*/),
            (v5/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionStage",
          "kind": "LinkedField",
          "name": "stage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "seq",
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v12/*:: as any*/),
              "concreteType": "EventCompetitionConnection",
              "kind": "LinkedField",
              "name": "events",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventCompetition",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v16/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Competition",
                      "kind": "LinkedField",
                      "name": "competition",
                      "plural": false,
                      "selections": [
                        (v9/*:: as any*/),
                        (v11/*:: as any*/),
                        (v3/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v3/*:: as any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "events(first:1)"
            },
            (v3/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "submissions(first:50)"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bibtex",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceAsideVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceBySlug",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceAsideFragment"
          },
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "concreteType": "WorkspaceVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DOI",
                "kind": "LinkedField",
                "name": "doi",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "thumbnail",
                        "value": true
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "EntityProfilePicFragment"
                  }
                ],
                "storageKey": null
              },
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Competition",
                "kind": "LinkedField",
                "name": "fromCompetition",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v11/*:: as any*/),
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v12/*:: as any*/),
                    "concreteType": "EventCompetitionConnection",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventCompetition",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v9/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "events(first:1)"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceVersionCardActionsFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceDOIFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceAsideVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceBySlug",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "license",
            "storageKey": null
          },
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "private",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "concreteType": "WorkspaceVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkspaceVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v13/*:: as any*/),
                      (v15/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v10/*:: as any*/),
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v20/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v14/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*:: as any*/)
                ],
                "storageKey": null
              },
              (v25/*:: as any*/)
            ],
            "storageKey": "versions(first:1)"
          },
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "WorkspaceAsideFragment_versions",
            "kind": "LinkedHandle",
            "name": "versions"
          },
          {
            "alias": "viewerCanEdit",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "UPDATE_WORKSPACE"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE\")"
          },
          (v9/*:: as any*/),
          (v19/*:: as any*/),
          {
            "alias": "baseVersions",
            "args": (v21/*:: as any*/),
            "concreteType": "WorkspaceVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:50)"
          },
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "concreteType": "WorkspaceVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v13/*:: as any*/),
              (v15/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v10/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v20/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "tagList",
                "args": (v26/*:: as any*/),
                "concreteType": "TaggableConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v14/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*:: as any*/)
                ],
                "storageKey": "tags(first:5)"
              },
              {
                "alias": "tagList",
                "args": (v26/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "TagListFragment_tagList",
                "kind": "LinkedHandle",
                "name": "tags"
              }
            ],
            "type": "Taggable",
            "abstractKey": "__isTaggable"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef5dd6f63896b147644337aba11edff0",
    "id": null,
    "metadata": {},
    "name": "WorkspaceAsideVersionQuery",
    "operationKind": "query",
    "text": "query WorkspaceAsideVersionQuery(\n  $owner: String!\n  $slug: String!\n  $version: Semver!\n) {\n  workspaceBySlug(owner: $owner, slug: $slug) {\n    ...WorkspaceAsideFragment\n    version(version: $version) {\n      id\n      doi {\n        full\n      }\n      entity {\n        __typename\n        username\n        ...EntityProfilePicFragment_49kWkb\n        id\n      }\n      createdAt\n      version\n      publishedAt\n      clonedFrom @ifAllowed {\n        id\n        version\n        workspace {\n          id\n          slug\n        }\n      }\n      fromCompetition @ifAllowed {\n        id\n        title\n        slug\n        events(first: 1) {\n          nodes {\n            event {\n              slug\n              id\n            }\n            id\n          }\n        }\n      }\n      ...WorkspaceVersionCardActionsFragment\n      ...WorkspaceDOIFragment\n    }\n    id\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment TagFragment on Tag {\n  name\n}\n\nfragment TagListFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        ...TagFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment WorkspaceAsideFragment on Workspace {\n  id\n  shortDescription\n  license\n  createdAt\n  private\n  versions(first: 1) {\n    edges {\n      node {\n        id\n        doi {\n          full\n        }\n        entity {\n          __typename\n          username\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        createdAt\n        version\n        publishedAt\n        clonedFrom @ifAllowed {\n          id\n          version\n          workspace {\n            id\n            slug\n          }\n        }\n        fromCompetition @ifAllowed {\n          id\n          title\n          slug\n          events(first: 1) {\n            nodes {\n              event {\n                slug\n                id\n              }\n              id\n            }\n          }\n        }\n        ...WorkspaceVersionCardActionsFragment\n        ...WorkspaceDOIFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...TagListFragment\n  ...WorkspaceMetadataEditButtonFragment\n  ...WorkspaceVersionHistoryFragment\n}\n\nfragment WorkspaceDOIFragment on WorkspaceVersion {\n  id\n  bibtex\n  doi {\n    full\n    short\n    url\n  }\n}\n\nfragment WorkspaceMetadataEditButtonFragment on Workspace {\n  id\n  shortDescription\n  license\n  ...TagListFragment\n  ...taggableFragment\n  viewerCanEdit: viewerCan(action: UPDATE_WORKSPACE)\n}\n\nfragment WorkspacePublishButtonFragment on Workspace {\n  id\n  viewerCanCreateVersion: viewerCan(action: CREATE_WORKSPACE_VERSION)\n  baseVersions: versions(first: 50) {\n    nodes {\n      id\n      version\n      publishedAt\n    }\n  }\n}\n\nfragment WorkspaceVersionCardActionsFragment on WorkspaceVersion {\n  id\n  version\n  publishedAt\n  viewerCanPublish: viewerCan(action: PUBLISH_WORKSPACE_VERSION)\n  workspace {\n    id\n    slug\n    viewerCanCreateVersion: viewerCan(action: CREATE_WORKSPACE_VERSION)\n  }\n  fromCompetition @ifAllowed {\n    id\n    title\n    slug\n    currentStage {\n      noCode\n      submissionDeadline\n      id\n    }\n    events(first: 1) {\n      nodes {\n        event {\n          slug\n          id\n        }\n        id\n      }\n    }\n  }\n  submissions(first: 50) {\n    nodes {\n      id\n      entity {\n        __typename\n        username\n        id\n      }\n      stage {\n        seq\n        events(first: 1) {\n          nodes {\n            event {\n              slug\n              id\n            }\n            competition {\n              slug\n              title\n              id\n            }\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n  ...WorkspaceVersionPublishButtonFragment\n}\n\nfragment WorkspaceVersionHistoryFragment on Workspace {\n  id\n  slug\n  createdAt\n  ...WorkspacePublishButtonFragment\n}\n\nfragment WorkspaceVersionPublishButtonFragment on WorkspaceVersion {\n  id\n  version\n  publishedAt\n  viewerCanPublish: viewerCan(action: PUBLISH_WORKSPACE_VERSION)\n}\n\nfragment taggableFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        name\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "0b96774367e27475ec75a6be02e8bfee";

export default node;
